/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import StudentListShimmer from '../Directory/Components/Table/StudentListShimer';
import { useDispatch, useSelector } from 'react-redux';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './Components/Table';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import CardHeader from '../../../components/CardHeader';
import { StudentsDirectory } from './studentSlice';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import Toast from '../../../components/Toast';
import Debounce from '../../../CommonMethods/Debounce'
import SidePopup from "./Components/SidePopup";
import InvoiceScheduledModal from './InvoiceScheduledModal';


const ManageStudentsDirectoryList  = () => {
    const { setToastmessage } = useContext(GlobalContext);
    // let  params = roles?.includes('directory') ? {page_number:1,limit:10} : {}
    const [searchParams, setSearchParams] = useSearchParams({page_number:1,limit:10});
    const [toastErrorMessage,setToastErrorMessage] = useState("")
    const dispatch = useDispatch();
    const StudentsDirectoryList = useSelector(state => state.StudentsDirectorySlice);
    const { List } = StudentsDirectoryList
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [FilterData, setFilterData] = useState({});
    const [FilterCheckbox, setFilterCheckBox] = useState({});
    const [filterCount, setFilterCount] = useState(0);
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const [ongoingAYName, setOngoingAYName] = useState(null);
    const [noAYString, setNOAYString] = useState('No AY Details')
    const [isSidePopup, setIsSidePopup] = useState(false);
    const [selectedPopupAcademicYear, setSelectedPopupAcademicYear] =
      useState("");
    const [selectedPopupClass, setSelectedPopupClass] = useState("");
    const [selectedPopupSection, setSelectedPopupSection] = useState("");
    const [academicYears, setAcademicYears] = useState([]);
    const [classes, setClasses]= useState([]);
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const [threeDottedButtonLoading, setThreeBottedButtonLoading] = useState(false)
    const [invoiceScheduledModalOpen, setInvoiceScheduledModalOpen] = useState(false);
    const placeholderOptions = [
        'Student Name / ID',
        "Parent's Name",
        'Academic Year',
        'Class / Section'
    ];
    const [dotedLoader, setDotLoader] = useState("")
    const [isBulkInvite, setIsBulkInvite] = useState(false);
    const navigate = useNavigate()

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        // setLoading(true);
        setSearchParams({page_number:1,limit:10})
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getStudentsDirectory = async () => {
        try {
            if (location.pathname === '/access-denied') {
                navigate('/access-denied');
                return;
            }
            setFirstLoading(false)
            setLoading(true)
            const branch_id = await GetBranchId()

            let params = new URLSearchParams(searchParams);
            if(searchParams.get('status') === null) {
                params.set('status', 'active');
                if(searchParams.get('filter') === null)
                {
                    params.set('filter', 'true');
                }
                setSearchParams(params);
            }

            params.delete('isScheduleModal')
            params.delete('transactionId')
            params.delete('totalStudents')
            params.delete('isBulkIssueTriggered')
            params.delete('isOngoingTermExists')

            params?.get("limit")&&params?.get("page_number")&&dispatch(StudentsDirectory(`students?branch_id=${branch_id.toString()}&${params.toString()}`)).then((response) => {
                if(response?.payload?.data?.data?.students?.length === 0 && searchParams.get('search')===null && searchParams.get('filter')===null&& response?.payload?.data?.data?.total_count === 0 ) {
                    setFirstLoading(true);
                } else {
                    setEmptyScreenMessage("No matching records found");  
                }
                if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  (Number(params?.get('page_number')) || 1 )) {
                    if(response?.payload?.data?.data.total_count !== 0) {
                        setEmptyScreenMessage("No data found");
                    } else {
                        setEmptyScreenMessage("No matching records found");
                    }
                } 
                setTimeout(()=>{
                    setLoading(false)
                }, 100)
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            if (error?.response?.status === 403) {
                console.error("403 Forbidden: Access denied", error);
                navigate('/access-denied');
            } else {
                console.error("Error:", error);
            }     
            setEmptyScreenMessage("No data found");
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    };

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("No matching records found");
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );
    const getAcademicYears = async () => {
        try{
            const branch_id = await GetBranchId();
            let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
            const response = await dataService.GetAPI(endpoint);
            const temp = response?.data?.data?.data;
            setAcademicYears(temp);
            getFilterData(temp);
            return temp; // Returning academic years data 
        } catch(error){
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } 
    };
    const getClasses = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=directory`;
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setClasses(temp)
    }

    /* `useEffect(() => { getInstitutionUsers(); }, [getInstitutionUsers]);` is a hook that is used to run
    the `getInstitutionUsers` function whenever the `getInstitutionUsers` function changes. In this case,
    the `getInstitutionUsers` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getInstitutionUsers` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response      
    data. */
    useEffect(() => {
        setLoading(true)
        setsearchFieldDebounce(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        
        if (searchParams.get('status') && searchParams.get('filter')) {
            getStudentsDirectory();
        }
    }, [searchParams]);

    useEffect(() => {
        const ensureSearchParams = () => {
            let params = Object.fromEntries(searchParams);
    
            if (!params.limit) {
                params.limit = '10';
            }
            if (!params.page_number) {
                params.page_number = '1';
            }
            if (!params.status) {
                params.status = 'active';
            }
            if (!params.filter) {
                params.filter = 'true';
            }
    
            setSearchParams({ ...params });
        };
    
        ensureSearchParams();
    }, [searchParams, setSearchParams]);

    const getFilterData = async () => {
        try {
            const branch_id = await GetBranchId();
            const response = await dataService.GetAPI(`students/list-filters?branch_id=${branch_id}&status=${searchParams.get("status")==null?"active":searchParams.get("status")}`, undefined, true);
            if (response?.data?.status === 403) {
                navigate('/access-denied');
            } else{
                const filterData = response.data.data;
    
                // Assuming `location` has the URL with query parameters
                const searchParams = new URLSearchParams(location.search);
                
                setOngoingAYName('')
                const showOngoingAY = searchParams.get('status') === 'active' && (filterData.academic_year.length === 1);
                
                if(showOngoingAY)
                {
                    setOngoingAYName(filterData.academic_year[0]===noAYString?'':filterData.academic_year[0]);
                }

                let filter_val = {};
                searchParams.forEach((value, key) => {
                    if (filterData.hasOwnProperty(key)) {
                        const splitValues = value.split(',').filter(val => val.trim() !== ""); // Filter out empty strings
                        if (splitValues.length > 0) {
                            filter_val[key] = splitValues;
                        }
                    }
                });
        
                // Calculate filter count
                let count = Object.values(filter_val).filter(val => val.length !== 0).length;
        
                // Update state once
                setFilterData(filterData);
                setFilterCheckBox(filter_val);
                setFilterCount(count);
            }
        } catch (error) {
            if (error?.response?.status === 403) {
                console.error("403 Forbidden: Access denied", error);
                navigate('/access-denied');
            } else {
                console.error("Error:", error);
            }  
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error("Error while fetching filter data:", error);
        }
    };

    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item]?.length !== 0) {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)

        } else {
            setFilterCount(0)
        }
    }
    
    const handleApplyFilter = (type) => {
        setEmptyScreenMessage("No matching records found");
        let params = Object.fromEntries(searchParams);
        
        if (type) {
            let flag = true;
            params["filter"] = true;
            params.page_number = 1;
    
            Object.keys(FilterCheckbox).map((item) => {
                if (FilterCheckbox[item]?.length !== 0) {
                    let val = "";
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`;
                    });
    
                    // Check if 'status' already exists in params
                    if (!params.hasOwnProperty('status')) {
                    }
    
                    params[item] = val.slice(0, -1);
                    setSearchParams({ ...params });
                    flag = false;
                } else {
                    delete params[item];
                    setSearchParams({ ...params });
                }
            });
    
            if (flag && params['status'] === 'active') {
                delete params.filter;
                setSearchParams({ ...params });
            }
        } else {
            if (!params.hasOwnProperty('status')) {
            }
    
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item];
            });
            setSearchParams({ ...params });
            setFilterCheckBox([]);
        }
    
        getCount(type);
    };
    
    const handleSampleFileDownload = () => {
        setDotLoader('sample')
        try {
            window.open(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.ap-south-1.amazonaws.com/public/students/sample_file_download/student_bulk_upload.xlsx`, '_blank');
            // getStudentsDirectory()
            setToastmessage("Sample file downloaded successfully");
        } catch (error) {
            setDotLoader('') 
            console.error('An error occurred:', error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
        setDotLoader('') 
    }

    useEffect(()=>{
        localStorage.getItem('access-denied') === 'true' ? navigate('/access-denied') : ''
        getFilterData()
    },[searchParams])

    const handleExportStudents = async () => {
        try {
            const branch_id = await GetBranchId()

            let params = new URLSearchParams(searchParams);
            if (searchParams.get('status') === null) {
                params.set('status', 'active');
                if (searchParams.get('filter') === null) {
                    params.set('filter', 'true');
                }
            }
            params.set('export', 'true');

            params.delete('isScheduleModal')
            params.delete('transactionId')
            params.delete('totalStudents')
            params.delete('isBulkIssueTriggered')
            params.delete('isOngoingTermExists')
            params.delete('page_number')
            params.delete('limit')

            const response = await dataService.GetAPI(`students?branch_id=${branch_id.toString()}&${params.toString()}`)
            setToastmessage(response?.data?.data?.message || "Students exported successfully")
            if (response?.data?.data?.pre_signed_url) {
                window.open(response?.data?.data?.pre_signed_url)
            }
        } catch (error) {
            console.error("Error:", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }

    const handleThreeDottedButton = (e) => {
        if(e.target.id === "Sample Upload File") {
            handleSampleFileDownload()
        } else if (e.target.id === "Upload Students") {
            setIsSidePopup(true);
            setIsBulkInvite(false);
            // handleImportFile(e)
        } else if (e.target.id === "Send Parent Invitations") {  
            setIsSidePopup(true);
            setIsBulkInvite(true);
        } else if (e.target.id === "Update Fee Structure") {
            navigate('/student-master/directory/update-fee-structure')
        } else if (e.target.id === "Export Students") {
            handleExportStudents()
        }
        else{
            let params = Object.fromEntries(searchParams);
            params["filter"] = true;
            params.page_number = 1;

            if(e.target.id === "Active Students"){
                params['status'] = 'active';
            }
            else{
                params['status'] = 'terminated,transferred';151473
            }
            setSearchParams({ ...params });
        }
    }

    const backToDirectory= (e) => {
        setLoading(true)
        let params = Object.fromEntries(searchParams);
        Object.keys(FilterCheckbox).map((item) => {
            delete params[item];
        });
        setSearchParams({ ...params });
        setFilterCheckBox([]);
        params['status'] = 'active';
        setSearchParams({ ...params})
    }



    const handleSidePopupClick = () => {
        setIsSidePopup(false);
        // Reset selections when closing
        setSelectedPopupAcademicYear("");
        setSelectedPopupClass("");
        setSelectedPopupSection("");
    };

    const handlePopupAcademicYearChange = (academicYear) => {
        setSelectedPopupAcademicYear(academicYear);
    };

    const handlePopupClassChange = (classItem) => {
        setSelectedPopupClass(classItem);
    };

    const handlePopupSectionChange = (section) => {
        setSelectedPopupSection(section);
    };

    useEffect(() => {
        getAcademicYears();
        getClasses();
    },[])

    useEffect(() => {
        if (searchParams.get("isScheduleModal")) {
            setInvoiceScheduledModalOpen(true)
        }
    }, [])

    const OnScheduleDialogClose = () => {
        removeScheduleParams()
        setInvoiceScheduledModalOpen(false)
    }

    const removeScheduleParams = () => {
        const params = new URLSearchParams(searchParams);
        params.delete("transactionId");
        params.delete("isScheduleModal");
        params.delete("totalStudents");
        params.delete("isBulkIssueTriggered");
        setSearchParams(params);
    };

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                AddButton={searchParams.get('status') == 'active' || searchParams.get('status') == null ? true : false}
                isback={searchParams.get('status') == 'active' || searchParams.get('status') == null ? false : true}
                backLocationFunction={backToDirectory}
                backTitle={'Show Active Students'}
                SearchInput={true}
                Tittle={searchParams.get('status') == 'active' || searchParams.get('status') == null || loading ? 'Student Directory' : 'Student Directory: Transferred/Terminated'}
                AddButtonName={'Add Student'}
                ApplyFilter={true}
                SearchValue={searchFieldDebounce}
                handleOnClickSearch={setsearchFieldDebounce}
                isClick='/student-master/directory/add-student'
                FilterData={FilterData}
                directoryPage={true}
                handleApplyFilter={handleApplyFilter}
                FilterCheckbox={FilterCheckbox}
                setFilterCheckBox={setFilterCheckBox}
                filterCount={filterCount}
                searchParams={searchParams}
                setLoading={setLoading}
                optimizedFn={optimizedFn}
                selectedFilterTerm="academic_year"
                handleSampleFileDownload={handleSampleFileDownload}
                dotedLoader={dotedLoader}
                // handleImportFile={handleImportFile}
                setIsSidePopup={setIsSidePopup}
                customSearchBarWidth={'318px'}
                customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                threeDottedButton={true}
                handleThreeDottedButton={handleThreeDottedButton}
                threeDottedButtonLoading={threeDottedButtonLoading}
                filterFromPage={'Student_Directory'}
            />
            <div class="mainDataCntnrListDiv scrollBlue_thick">
                {loading ? <StudentListShimmer classkey={"mt-[30px]"} />
                    : (
                        <>
                            <div className="-mx-1">
                                <Table
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickSort={handleSearchParams}
                                    sortValue={searchParams.get('sort') || ''}
                                    email={email}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    setLoading={setLoading}
                                    totalCount={List?.total_count}
                                    searchParams={searchParams}
                                    setSearchParams={setSearchParams}
                                    ongoingAYName={ongoingAYName}
                                />
                                {(List.total_count > Number(searchParams.get('limit'))) && <Pagination
                                    TotalCount={List.total_count}
                                    totalPageNumber={Math.ceil(List.total_count / Number(searchParams.get('limit')))}
                                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    limit={Number(searchParams.get('limit'))}
                                />}
                            </div>
                        </>
                    )}
            </div>
            {searchParams.get('isScheduleModal') && (
                <>
                    <div>show modal</div>
                    <InvoiceScheduledModal 
                        open={invoiceScheduledModalOpen}
                        onClose={OnScheduleDialogClose}
                        removeParams={removeScheduleParams}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                        studentCount={searchParams.get('totalStudents')}
                        transactionId={searchParams.get('transactionId')}
                        isBulkIssueTriggered={searchParams.get('isBulkIssueTriggered')}
                        isOngoingTermExists={searchParams.get('isOngoingTermExists')}
                    />
                </>
            )}
            {toastErrorMessage!=='' &&
                <Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
            {/* </div> */}
            {/* {uploadFiled && <UploadFiledResponceModel 
                uploadFiled={uploadFiled} 
                setUploadFiled={setUploadFiled} 
                filedDataRecodes={filedDataRecodes}
            />} */}
            {isSidePopup && 
                <SidePopup
                    handleSampleFileDownload = {handleSampleFileDownload}
                    handleSidePopupClick={handleSidePopupClick}
                    setIsSidePopup={setIsSidePopup}
                    isStudentUpload={true}
                    academicYear={ ""}
                    className={""}
                    sectionName={ ""}
                    // handleUpload={handleActualSave}
                    getStudentsDirectory={getStudentsDirectory}
                    buttonLoading={loading}
                    uploadButtonText={"Upload"}
                    academicYears={academicYears}
                    classes={classes}
                    sections={FilterData?.section_}
                    selectedAcademicYear={selectedPopupAcademicYear || ""}
                    selectedClass={selectedPopupClass  || ""}
                    selectedSection={selectedPopupSection || ""}
                    onAcademicYearChange={handlePopupAcademicYearChange}
                    onClassChange={handlePopupClassChange}
                    onSectionChange={handlePopupSectionChange}
                    isBulkInvite = {isBulkInvite} // 👈 NEW
                />
            }
        </CardHeader>
    );
}

export default ManageStudentsDirectoryList;
